import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-plugin-web-awesome',
	templateUrl:'./WebAwesomePluginPage.html',
	styles: [],
	styleUrls:['./WebAwesomePluginPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WebAwesomePluginPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_689 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>web-awesome</artifactId>
</dependency>
\`\`\``;
	mdContent_690 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:web-awesome:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_691 = `\`\`\`java
var card = new WaCard<>();
card.setAppearance(Appearance.Outlined);

var tabs = new WaTabs<>();
var tab1 = new WaTab<>("Overview");
var panel1 = new WaTabPanel<>();
panel1.add(new WaText<>().setText("Tab content here"));
tabs.add(tab1);
tabs.add(panel1);
\`\`\``;
	mdContent_692 = `\`\`\`java
var card = new WaCard<>();
card.setAppearance(Appearance.Outlined);

var button = new WaButton<>("Click Me", Variant.Brand);
button.setAppearance(Appearance.Filled);

var stack = new WaStack<>();
stack.setGap(PageSize.Medium);
stack.add(card);
stack.add(button);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
